/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Device Base Modules (@accedo/xdk-base-modules) 4.1.4
* 
*******************************************************************************/
import{klass,IStorage}from"@accedo/xdk-core";export default klass.create([IStorage],{},{set(){},get(){},unset(){},clear(){}});